// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const FolderChangeIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path d="M13.84 2.69h.02c.69-.04 2.12-.09 2.6.43.69.72.94.8 1.93.78.69-.02 1.42 0 2.1 0 2.2-.05 2.02 1.79 2 3.37-.03 1.62.35 3.46-1.86 3.57-1.47.03-3.06 0-4.54 0H14.6q-.63.01-1.25-.05c-.77-.1-1.35-.9-1.37-1.64q0-1.15.02-2.29V5.29c-.01-.34-.04-.75.03-1.07.2-1 .87-1.46 1.82-1.53m0 10.48c.74-.04 2-.1 2.58.4.33.29.62.71 1.12.76 1 .1 2.05.03 3.07.05 2.29.04 1.83 2.21 1.87 3.8.03 1.56.13 3.04-1.86 3.14-1.46.03-3.05 0-4.5 0h-1.5c-.66 0-1.47.08-2-.37-.36-.32-.63-.83-.64-1.32v-3.86c-.01-.31-.03-.8.03-1.09q.1-.5.43-.9c.37-.42.85-.57 1.4-.6" />
      <path
        d="M2.32 2.68c.38.01.87.33.91.73.05.42.03.83.03 1.25v2.1h7v1.76h-7v5.27c0 .49-.03 3.1.06 3.37.2.14 2.13.09 2.5.08h4.45V19H5.8c-.82 0-1.76.04-2.57-.03-1.02-.09-1.73-1.07-1.73-2.06V14.7l-.01-4.17V3.61q-.01-.18.07-.35c.18-.37.4-.45.75-.58"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default FolderChangeIcon;
